






















































/* eslint-disable class-methods-use-this */

import { Vue, Component, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import CdkStyle from "../CdkStyle";
import { THEME_BTN_DETAIL_ACTION } from "@/constants/theme";
import useMatomoEvent from "@/composition/useMatomoEvent";
import useSharingActions from "@/composition/useSharingActions";

@Component({
  inject: ["eventBus"],
  components: {
    CdkStyle
  },
  setup() {
    const { copyToClipboard, download } = useSharingActions();

    const trackShareEvent = () => {
      useMatomoEvent({
        category: "Detail View",
        action: "Click Teilen",
        name: "Teilen"
      });
    };

    const trackCopyTextEvent = () => {
      useMatomoEvent({
        category: "Detail View",
        action: 'Click "Text kopieren" within Teilen',
        name: "Text kopieren within Teilen"
      });
    };

    const trackPrintTextEvent = () => {
      useMatomoEvent({
        category: "Detail View",
        action: 'Click "Text drucken" within Teilen',
        name: "Text drucken within Teilen"
      });
    };

    const trackDownloadEvent = () => {
      useMatomoEvent({
        category: "Detail View",
        action: 'Click "Download" within Teilen',
        name: "Download"
      });
    };

    return {
      copyToClipboard,
      download,
      trackShareEvent,
      trackCopyTextEvent,
      trackPrintTextEvent,
      trackDownloadEvent
    };
  },
  computed: {
    ...mapState("auth", ["token"]),
    ...mapState("stageconfig", ["config"])
  }
})
export default class Feed extends Vue {
  @Prop({ type: String, required: true }) plainText!: string;

  @Prop({ type: Boolean, required: false, default: false }) isPicture?: Boolean;

  @Prop({ type: String, required: false, default: "" }) residref?: String;

  // NB: eventBus is injected
  eventBus;

  token: string;

  config: object;

  THEME_BTN_DETAIL_ACTION = THEME_BTN_DETAIL_ACTION;

  printStyles: string = `
    @media print {
      .v-toolbar--fixed,
      .CdkNavigation,
      .List,
      .v-footer,
      .v-overlay,
      .v-menu__content {
        display: none !important;
      }

      .container {
        max-width: initial !important;
        padding: 0 !important;
      }

      .application,
      .u-bgApp {
        background-color: white !important;
        color: black !important;
      }

      main.v-content {
        padding: 0 !important;
      }

      .Feed-navigationDrawer {
        position: static !important;
        margin-top: 0 !important;
        width: 100% !important;
        max-height: initial !important;
        max-width: initial !important;
        height: initial !important;
      }

      .application--wrap {
        min-height: initial;
      }

      .SlcApp {
        height: initial !important;
        overflow: auto !important;
      }
    }
  `;

  /**
   * Triggers the browsers print dialog
   */
  print(): void {
    window.print();
  }
}
